import React from 'react';
import { ReactComponent as TaxWhiteIcon } from 'qs-assets/Media/tax-white.svg';
import './styles.scss';

export default ({ width, height, fill, classes = '' }) => {
  return (
    <TaxWhiteIcon style={{ width, height, fill }} className={`settingsIconComponent ${classes}`} />
  );
};
